// 六枚连续打卡徽章的图案，和 STREAK_MILESTONES 一一对应。
// 外形统一是圆角六边形，颜色从浅到深、从冷到暖，越往后越隆重；图案画在 64×72 的画布里，中心约在 (32, 35)。
// fill: 图案的实心部分；stroke: 线条部分。颜色用 tokens.css 里的 --badge-* 令牌。
export const MILESTONE_BADGES = [
  {
    // 3 天 · 迈出第一步：破土的嫩芽
    color: 'var(--badge-sprout)',
    stroke: ['M32 47V31', 'M24 47H40'],
    fill: [
      'M32 36C25 36 21 31.5 21 25C28 25 32 29.5 32 36Z',
      'M32 32C32 25.5 36 21 43 21C43 27.5 39 32 32 32Z'
    ]
  },
  {
    // 7 天 · 一周的坚持：一团火
    color: 'var(--badge-flame)',
    stroke: [],
    fill: [
      'M32 19C34.5 26 42 30 42 39C42 45.5 37.5 49 32 49C26.5 49 22 45.5 22 39.5C22 34.5 25 32 26.5 28C27.5 31.5 29 33 30.5 33C29.5 28 30 23.5 32 19Z'
    ],
    inner: ['M32 33C34 37.5 37 39.5 37 43C37 46 34.8 48 32 48C29.2 48 27 46 27 43.3C27 40.5 29.5 39 30 36.5C31 38 32 38.5 33 38.5C32.3 36.5 31.8 35 32 33Z']
  },
  {
    // 14 天 · 渐入佳境：一路往上走的折线
    color: 'var(--badge-rise)',
    stroke: ['M21 45L27 38L33 41L43 27', 'M37 27H43V33', 'M21 49H43'],
    fill: []
  },
  {
    // 30 天 · 一个月的积累：月亮和星星
    color: 'var(--badge-moon)',
    stroke: [],
    fill: [
      'M35 21C27.5 21.5 22 27.5 22 35C22 42.7 28.3 49 36 49C39.5 49 42.6 47.7 45 45.5C37.5 45.5 31.5 39.5 31.5 32C31.5 27.6 32.8 23.8 35 21Z',
      'M41 24L42.4 27.6L46 29L42.4 30.4L41 34L39.6 30.4L36 29L39.6 27.6Z'
    ]
  },
  {
    // 60 天 · 让习惯生根：有根的树
    color: 'var(--badge-root)',
    stroke: ['M32 33V44', 'M32 44C29 44 26 46 24 49', 'M32 44C35 44 38 46 40 49', 'M32 44V49'],
    fill: ['M32 18C38 18 42.5 22.5 42.5 28C42.5 33.5 38 36 32 36C26 36 21.5 33.5 21.5 28C21.5 22.5 26 18 32 18Z']
  },
  {
    // 100 天 · 百日同行：王冠
    color: 'var(--badge-crown)',
    stroke: [],
    fill: [
      'M20 43L21.5 25L27.5 32L32 21L36.5 32L42.5 25L44 43Z',
      'M20 46H44V49H20Z'
    ]
  }
]

// 圆角六边形外框和内圈
export const BADGE_FRAME = 'M32 4L59 19.5V50.5L32 66L5 50.5V19.5Z'
export const BADGE_INNER = 'M32 10L53.5 22.5V47.5L32 60L10.5 47.5V22.5Z'
